import { cn } from "logic/utils";
import type { ReactNode } from "react";

import { Footer } from "../Footer";

import { TopBar } from "./TopBar";

type Props = {
  children: ReactNode;
  className?: string;
};

export function AppShell(props: Props) {
  const { children, className } = props;

  return (
    // `--topbar-height` is the bar's own height (36px control + 2x16px padding),
    // declared once here so the content column's min-height below cannot drift
    // from it.
    <div className={cn("relative min-h-screen bg-surface-background [--topbar-height:68px]", className)}>
      {/* Figma clips the 474px-tall texture to the top 188px of the page, so the
          dot pattern fades out before the content starts (node 3540:3949). */}
      <div aria-hidden className="pointer-events-none absolute inset-x-0 top-0 h-[188px] overflow-hidden">
        <img alt="" className="h-[474px] w-full max-w-none" src="/svg/header-texture.svg" />
      </div>

      <div className="relative flex min-h-screen flex-col">
        <TopBar className="h-(--topbar-height)" />

        {/* Side padding and top inset differ per frame: 20/16 on mobile (402),
            120/36 on desktop (1280). The 36px column gap is the same on both.
            The 120px gutter waits for the desktop frame's own width — applying it
            earlier squeezes the column below the 1040px the table needs. */}
        {/* The min-height keeps the footer at or below the fold: `flex-1` alone
            leaves it riding up under short content, since the footer's own
            height already pushes the column past the viewport. */}
        <main className="flex min-h-[calc(100vh-var(--topbar-height))] flex-1 flex-col px-5 xl:px-[120px]">
          <div className="mx-auto flex w-full max-w-[1040px] flex-1 flex-col gap-9 pt-4 xl:pt-9">{children}</div>
        </main>

        {/* Not in the frame, which ends at the table — kept so the loans route
            does not lose the footer it had under the old chrome. */}
        <Footer />
      </div>
    </div>
  );
}
